// @ts-nocheck

import React, { ReactNode, useContext } from "react";
import cn from "classnames";

import globalFormStyles from "../global.formElements.module.scss";
import FieldMessage from "../FieldMessage";
import { RadioGroupProps } from "./RadioGroup.props";
import LabelTextItem from "../../LabelTextItem";
import Label from "../Label";

import { FormContext, useFormField } from "../../Form";

/**
 * @deprecated Use `import { RadioGroup } from capitalrx-components-2.0/lib/forms` instead.
 */
const RadioGroup: React.FC<RadioGroupProps> = (props: RadioGroupProps) => {
  const {
    children,
    name,
    onChange,
    id,
    label,
    validate,
    helperText,
    disabled,
    displayReadOnlyFieldInline,
    large,
    containerClassName,
    readOnly,
    useAsterisk,
    isLoading,
  } = props;

  const { formState, readOnly: readOnlyForm } = useContext(FormContext);
  const { errors, isFormLoading } = formState;

  const fieldValue = useFormField(name);
  const radioContainerClass = cn(globalFormStyles["form-field-container"], containerClassName);
  const displayLabel = label && <Label id={`label-${id}`} label={label} validate={validate} useAsterisk={useAsterisk} />;
  const readyOnlyStyles = cn({ [globalFormStyles["selection-field-read-only"]]: !displayReadOnlyFieldInline });

  const renderChildrenWithProps = (child: ReactNode, noLabel: boolean): ReactNode => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        id: `${id}-${child.props.value.split(" ").join("-").toLowerCase()}`,
        errors,
        validate,
        helperText,
        isLoading: isLoading || isFormLoading,
        name: name,
        readOnly,
        large: large,
        disabled: disabled ? disabled : child.props.disabled,
        label: noLabel ? "" : child.props.label,
        onChange,
      });
    }
    return child;
  };

  let component = null;
  if (readOnly || readOnlyForm) {
    const radioValue = fieldValue && new Array(String(fieldValue)).filter(Boolean).join("\r\n");
    component = (
      <LabelTextItem
        id={id}
        label={label}
        displayInline={displayReadOnlyFieldInline}
        body={radioValue}
        isLoading={isLoading || isFormLoading}
        className={readyOnlyStyles}
      />
    );
  } else {
    component = (
      <>
        {displayLabel}
        <div className={globalFormStyles["selection-field-children-container"]}>
          {React.Children.map(children, (child: ReactNode) => {
            return renderChildrenWithProps(child, false);
          })}
        </div>
        <FieldMessage id={id} helperText={helperText} errors={errors} name={name} />
      </>
    );
  }

  return <div className={radioContainerClass}>{component}</div>;
};

/**
 * @deprecated
 */
export default RadioGroup;
